const STEPS = [
  {
    step: "01",
    icon: "ri-search-eye-line",
    title: "마음에 드는 숙소 선택",
    desc: "지역, 인원, 특징으로 15개 숙소 중 원하는 곳을 고르세요. 모든 숙소는 한국인 호스트가 직접 운영합니다.",
    color: "bg-amber-50 text-amber-600",
    border: "border-amber-200",
  },
  {
    step: "02",
    icon: "ri-kakao-talk-line",
    title: "카카오톡으로 호스트 연락",
    desc: "숙소 카드의 에어비앤비 링크를 클릭해 예약 전 호스트에게 한국어로 직접 문의할 수 있어요.",
    color: "bg-yellow-50 text-yellow-600",
    border: "border-yellow-200",
  },
  {
    step: "03",
    icon: "ri-calendar-check-line",
    title: "에어비앤비에서 예약 확정",
    desc: "에어비앤비 공식 플랫폼을 통해 안전하게 결제하고 예약을 확정하세요. 에어비앤비의 강력한 여행자 보호 정책이 적용됩니다.",
    color: "bg-rose-50 text-rose-600",
    border: "border-rose-200",
  },
  {
    step: "04",
    icon: "ri-door-open-line",
    title: "비대면 체크인 or 직접 영접",
    desc: "비대면 도어락 코드 안내 또는 호스트 직접 영접 중 선택 가능. 체크인부터 퇴실까지 한국어 안내가 제공됩니다.",
    color: "bg-green-50 text-green-600",
    border: "border-green-200",
  },
];

export default function BookingGuideSection() {
  return (
    <section id="booking-guide" className="py-12 sm:py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 text-amber-600 text-xs font-semibold tracking-widest uppercase mb-3">
            <i className="ri-guide-line"></i>
            BOOKING GUIDE
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-stone-800 mb-3">
            예약은 이렇게 하세요
          </h2>
          <p className="text-stone-500 text-sm max-w-lg mx-auto leading-relaxed">
            처음이라도 괜찮아요. 한국어로 모든 과정을 안내해 드립니다.
            4단계만 따라오시면 후쿠오카 여행 준비 완료!
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-10 sm:mb-14">
          {STEPS.map((s, idx) => (
            <div
              key={s.step}
              className={`relative bg-white rounded-2xl p-5 sm:p-6 border ${s.border} hover:scale-105 transition-transform duration-300 cursor-default`}
            >
              <div className="text-4xl font-black text-stone-100 absolute top-4 right-5 select-none">
                {s.step}
              </div>
              <div className={`w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center rounded-xl ${s.color} mb-3 sm:mb-4`}>
                <i className={`${s.icon} text-lg sm:text-xl`}></i>
              </div>
              <h3 className="font-bold text-stone-800 text-sm mb-2">{s.title}</h3>
              <p className="text-xs text-stone-500 leading-relaxed">{s.desc}</p>

              {idx < STEPS.length - 1 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 z-10">
                  <div className="w-6 h-6 flex items-center justify-center bg-white border border-stone-200 rounded-full">
                    <i className="ri-arrow-right-s-line text-stone-400 text-sm"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Info Banner */}
        <div className="bg-amber-500 rounded-2xl p-5 sm:p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-5 sm:gap-6">
            <div>
              <h3 className="text-white font-bold text-base sm:text-lg mb-2">에어비앤비로 안전하게 예약하세요</h3>
              <p className="text-amber-100 text-xs sm:text-sm leading-relaxed max-w-lg">
                모든 숙소는 에어비앤비 공식 플랫폼을 통해 예약합니다.
                에어비앤비의 여행자 보호 정책, 환불 보장, 24시간 고객지원이 적용됩니다.
                한울은 숙소 큐레이션만을 제공하며, 결제는 에어비앤비에서 안전하게 이루어집니다.
              </p>
            </div>
            <div className="flex flex-col gap-2.5 sm:gap-3 shrink-0">
              <div className="flex items-center gap-2 sm:gap-3 text-white text-xs sm:text-sm">
                <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center bg-white/20 rounded-full shrink-0">
                  <i className="ri-shield-check-line"></i>
                </div>
                에어비앤비 여행자 보호 적용
              </div>
              <div className="flex items-center gap-2 sm:gap-3 text-white text-xs sm:text-sm">
                <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center bg-white/20 rounded-full shrink-0">
                  <i className="ri-refund-2-line"></i>
                </div>
                유연한 환불 정책
              </div>
              <div className="flex items-center gap-2 sm:gap-3 text-white text-xs sm:text-sm">
                <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center bg-white/20 rounded-full shrink-0">
                  <i className="ri-customer-service-2-line"></i>
                </div>
                한국어 호스트 직접 연락 가능
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
